/**
 * Generate SHA-256 hash from file content
 * @param {File} file - The file to generate hash for
 * @returns {Promise<string>} - SHA-256 hash as hex string
 */
export const generateFileHash = async (file) => {
	try {
		// Combine file content with filename for unique hash
		const arrayBuffer = await file.arrayBuffer();
		const filenameBuffer = new TextEncoder().encode(file.name);
		
		// Create combined buffer: content + filename
		const combinedBuffer = new Uint8Array(arrayBuffer.byteLength + filenameBuffer.byteLength);
		combinedBuffer.set(new Uint8Array(arrayBuffer), 0);
		combinedBuffer.set(filenameBuffer, arrayBuffer.byteLength);
		
		// Generate hash from combined data
		const hashBuffer = await crypto.subtle.digest('SHA-256', combinedBuffer);
		const hashArray = Array.from(new Uint8Array(hashBuffer));
		return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
	} catch (error) {
		console.error('Error generating file hash:', error);
		// Fallback: use file name, size and last modified date
		return `${file.name}_${file.size}_${file.lastModified}`.replace(/[^a-zA-Z0-9]/g, '');
	}
};
